import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestArticles() {
  const recent = getRecentArticles(6);

  const getCategoryName = (slug: string) => {
    return categories.find((c) => c.slug === slug)?.name || '';
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              最新攻略
            </h2>
            <p className="text-sm text-foreground-600">
              持续更新的2048深度攻略，第一时间掌握最新技巧
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {recent.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-28 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs px-2 py-0.5 bg-primary-100 text-primary-700 rounded font-medium whitespace-nowrap">
                    {getCategoryName(article.categorySlug)}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}